/*
 * @Description: 七牛直传公共方法
 * buildUploadKey: 不再使用原始文件名拼 key，避免 %00、../、.php.jpg 等构造的文件名进入存储路径。
 * 后缀只保留白名单内的，其余文件不带后缀。原始文件名请单独保存用于展示。
 * getUploadErrorMessage: 将七牛返回的错误转换为用户可读的提示。
 */
const ALLOWED_EXTS = [
  'png', 'jpg', 'jpeg', 'bmp', 'gif', 'webp',
  'pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx',
];

export function getSafeExt (fileName) {
  const match = /\.([a-zA-Z0-9]+)$/.exec(fileName || '');
  const ext = match ? match[1].toLowerCase() : '';
  return ALLOWED_EXTS.includes(ext) ? ext : '';
}

export function buildUploadKey (file, prefix) {
  const random = `${Date.now()}${Math.random().toString(36).slice(2, 10)}`;
  const ext = getSafeExt(file && file.name);
  const name = ext ? `${random}.${ext}` : random;
  return prefix ? `${prefix}/${name}` : name;
}

// 七牛按文件内容侦测出的类型 -> 中文名称，用于上传失败提示
const MIME_TYPE_NAMES = {
  'text/html': ' HTML 网页文件',
  'text/plain': '纯文本文件',
  'text/xml': ' XML 文件',
  'application/xml': ' XML 文件',
  'application/json': ' JSON 文件',
  'text/javascript': ' JavaScript 脚本',
  'application/javascript': ' JavaScript 脚本',
  'application/x-javascript': ' JavaScript 脚本',
  'text/x-php': ' PHP 脚本',
  'application/x-php': ' PHP 脚本',
  'application/x-httpd-php': ' PHP 脚本',
  'text/x-shellscript': ' Shell 脚本',
  'application/x-sh': ' Shell 脚本',
  'image/svg+xml': ' SVG 图片',
  'application/x-msdownload': '可执行程序',
  'application/x-dosexec': '可执行程序',
  'application/x-executable': '可执行程序',
  'application/java-archive': ' Java 程序包',
  'application/x-rar-compressed': ' RAR 压缩包',
  'application/x-7z-compressed': ' 7z 压缩包',
  'application/octet-stream': '无法识别的二进制文件',
};

function parseQiniuError (err) {
  if (!err) return '';
  if (typeof err === 'string') {
    try {
      return JSON.parse(err).error || err;
    } catch (e) {
      return err;
    }
  }
  if (err.error) return err.error;
  return parseQiniuError(err.message);
}

// 兼容 el-upload 的 on-error(err)、a-upload 的 file.response / file.error、axios 的 error.response.data
export function getUploadErrorMessage (err) {
  const msg = parseQiniuError(err) || '';
  if (/limited mimeType/i.test(msg)) {
    // 七牛错误格式：limited mimeType: this file type (text/html) is forbidden to upload
    const match = /file type \(([^)]+)\)/i.exec(msg);
    if (!match) {
      return '不支持该文件类型';
    }
    const mimeType = match[1];
    const typeName = MIME_TYPE_NAMES[mimeType.toLowerCase()];
    return typeName
      ? `不支持该文件类型：经检测，该文件实际为${typeName}（${mimeType}）`
      : `不支持该文件类型：经检测，该文件实际类型为 ${mimeType}`;
  }
  if (/exceed FsizeLimit|file too large|request entity too large/i.test(msg)) {
    return '文件大小超出限制';
  }
  if (/file exists/i.test(msg)) {
    return '文件已存在，请重新上传';
  }
  if (/expired token|bad token|token out of date|invalid token/i.test(msg)) {
    return '上传凭证已过期，请刷新页面后重试';
  }
  return '文件上传失败，请重试';
}
